/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_CtaInputs */

const he_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת חשבון`)
};

const en_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Auth_Signup_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_cta = /** @type {((inputs?: Auth_Signup_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_cta(inputs)
	return en_auth_signup_cta(inputs)
});